{
    "AllTelServer": "[Alle telefonieservers]",
    "AnyPartition": "[Elke partitie]",
    "AnyDevices": "[Elk apparaat]",
    "AnyAgents": "[Elke ACD-agent]",
    "AnyAgentForDevice": "[Elk op ingesteld apparaat]",
    "AnyDeviceForAgent": "[Elke met ingestelde ACD-agent]",
    "DeviceValidation": "Serviceniveau-instellingen",
    "AgentValidation": "Een beheerder kan geen agentmachtigingsniveau instellen",
    "PermissionsLanguage_PermissionsNote": "Serviceniveau-instellingen",
    "PermissionsLanguage_CmEnvironment": "CME-details",
    "PermissionsLanguage_TelServer": "Telefonieserver:",
    "PermissionsLanguage_Partition": "partitie:",
    "PermissionsLanguage_Device": "Groep\/Apparaat:",
    "PermissionsLanguage_AndOrAgent": "Tussenpersoon:",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Voor dit gebruikerstype moet een toestemmingsapparaat zijn ingesteld",
    "EssentialsDeviceValidation_MST": "Een CXA Standard-gebruiker moet een apparaat met toestemmingen hebben ingesteld",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Supervisor-machtigingen synchroniseren vanuit telefonieplatform"
}